// @ts-nocheck
/* eslint-disable */
/**
 * @const {Bool} je podporovaný atribut download na odkazu?
 */
Mapy.Util.downloadSupported = (function() {
	var a = Mapy.Util.node("a");
	var isMacOSWebView = /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent);
	var isFFiOS = navigator.userAgent.match("FxiOS");
	return ("download" in a || "msSaveOrOpenBlob" in navigator) && !isMacOSWebView && !isFFiOS;
})();

/**
 * Vyvolá dialog pro stažení souboru, který dostane jako instanci Blobu
 * @param {Blob} blob tělo souboru jako Blob
 * @param {String} filename jméno, pod jakým chceme soubor nabídnout ke stažení
 */
Mapy.Util.startBlobDownload = function(blob, filename) {
	if (navigator.msSaveOrOpenBlob) {
		navigator.msSaveOrOpenBlob(blob, filename);
	} else {
		var url = window.URL.createObjectURL(blob);
		var a = Mapy.Util.node("a", {
			href: url,
			download: filename
		});
		a.style.display = "none";
		a.setAttribute("data-log-ignore", "1");
		document.body.appendChild(a);
		a.click();

		// kvuli FF je pry treba s odstranenim pockat, tak nejaky cas pockame
		setTimeout(function() {
			window.URL.revokeObjectURL(url);
			a.remove();
		}, 10000);
	}
};

/**
 * Vyvolá dialog pro stažení souboru na dané URL pomocí formuláře či odkazu
 * @param {String} url URL, ze které se bude stahovat
 * @param {object} data parametry dotazu
 * @param {String} m metoda POST nebo GET
 */
Mapy.Util.startDirectDownload = function(url, data, m) {
	var method = m || "POST";

	if (method == "POST") {
		var form = Mapy.Util.node("form", { action: url, method: method, target: "_blank" }, { display: "none" });
		for (let param in data) {
			if (data[param].length == 1) {
				form.appendChild(Mapy.Util.node("input", { type: "text", name: param, value: data[param][0] }));
			} else {
				data[param].forEach(function(p) {
					form.appendChild(Mapy.Util.node("input", { type: "checkbox", checked: "checked", name: param, value: p }));
				});
			}
		}

		document.body.appendChild(form);
		form.submit();

		setTimeout(function() {
			form.remove();
		}, 10000);
	} else {
		// TODO: zatim neni potreba, ale kdyby nekdy nekdo chtel posilat i pri GETu data jeste extra, muselo by se poladit
		var a = Mapy.Util.node("a", {
			href: url,
			target: "_blank"
		}, { display: "none" });
		document.body.appendChild(a);
		a.click();

		setTimeout(function() {
			a.remove();
		}, 10000);
	}
};

/**
 * ZApočne stahování souboru jedním či druhým podporovaným způsobem (preferovaný je XHR dotaz a následné stažení Blobu)
 * @param {object} opts konfigurace celého downloadu
 * @param {object} opts.data parametry stahování (pro XHR dotaz či jako parametry do URL u GETu nebo položky formuláře do POSTu)
 * @param {String} opts.url URL odkud se bude stahovat
 * @param {Function} opts.onSuccess callback při úspěšném stažení
 * @param {Function} opts.onError callback při neúspěšném stažení
 * @param {String} opts.filename název, pod jakým nabídneme soubor ke stažení v případě XHR/Blob metody
 * @param {Bool} opts.fileTypeFromHeader použít MIME typ z odpovědi?
 * @param {String} opts.method metoda POST nebo GET
 */
Mapy.Util.startDownload = function(opts) {
	var dummy = function() {};
	var data = opts.data || {};
	var url = opts.url || "/";
	var onSuccess = opts.onSuccess || dummy;
	var onError = opts.onError || dummy;
	var filename = opts.filename || "export";
	var fileTypeFromHeader = opts.fileTypeFromHeader || false;
	var method = opts.method || "POST";

	if (Mapy.Util.downloadSupported) {
		// dame dohromady parametry
		var params = new URLSearchParams();
		for (let param in data) {
			data[param].forEach(function(p) {
				params.append(param, p);
			});
		}

		// posleme na server
		var xhr = new XMLHttpRequest();
		xhr.open(method, url);
		xhr.responseType = "blob";
		xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
		xhr.withCredentials = true;
		var cb = function(e) {
			if (fileTypeFromHeader) {
				switch (xhr.getResponseHeader("Content-Type")) {
					case "application/gpx+xml":
						filename = filename.replace(/(\.\w{2,})$/, "") + ".gpx";
						break;
					case "application/zip":
						filename = filename.replace(/(\.\w{2,})$/, "") + ".zip";
						break;
				}
			}
			if (e.target.status == 200) {
				onSuccess();
				Mapy.Util.startBlobDownload(new Blob([e.target.response], { type: e.target.response.type }), filename);
			} else {
				onError(e.target);
			}
		};
		xhr.onload = cb;
		xhr.onerror = e => onError(e.target);
		xhr.send(params);
	} else {
		onSuccess();
		Mapy.Util.startDirectDownload(url, data, method);
	}
};
